"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var ResourcePreloaderService = (function () {
    function ResourcePreloaderService(http) {
        this.http = http;
    }
    ResourcePreloaderService.prototype.load = function () {
        var _this = this;
        this.toolInfosPromise = this.http.get(require('../resources/localizable/en-lproj/ToolInfos.xml'))
            .toPromise()
            .then(function (data) { return _this.toolInfos = data.text(); });
        this.stylesPromise = this.http.get(require('../resources/FigureStyles.xml'))
            .toPromise()
            .then(function (data) { return _this.styles = data.text(); });
        this.levelsPromise = this.http.get(require('../resources/levels/Levels.xml'))
            .toPromise()
            .then(function (data) { return _this.levels = data.text(); });
        return Promise.all([this.toolInfosPromise, this.stylesPromise, this.levelsPromise]);
    };
    return ResourcePreloaderService;
}());
ResourcePreloaderService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ResourcePreloaderService);
exports.ResourcePreloaderService = ResourcePreloaderService;



//////////////////
// WEBPACK FOOTER
// ./src/services/resourcePreloader.service.ts
// module id = 146
// module chunks = 0